<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="12" lg="12" class="pa-2 ma-2" >
                <v-card>
                    <v-card-title>
                        Run Case Number
                        <v-btn
                            x-small
                            fab
                            class="ml-3"
                            :color="
                                chk_data_case_main == false
                                    ? 'green accent-2'
                                    : 'amber'
                            "
                            @click="get_dataRunCaseNumber()"
                            ><v-icon>mdi-refresh</v-icon></v-btn
                        >               
                        <v-spacer></v-spacer>
                        <v-btn icon @click="showRunCaseNumber = !showRunCaseNumber">
                            <v-icon>{{
                                showRunCaseNumber ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                        </v-btn>
                    </v-card-title>
                <v-expand-transition>
                    <div v-show="showRunCaseNumber">
                        <v-container fluid>
                            <v-row>
                                <!-- <v-col cols="12" >
                                     <v-text-field
                                     v-model="case_id"
                                     label="Case Number"
                                     outlined
                                     dense
                                     :disabled="data_case.length > 0"
                                ></v-text-field>
                                </v-col>
                                <v-col cols="12" :style="{ marginTop: '-30px' }">
                                <v-btn color="" class="primary--text" block @click="sendcase_id()" :disabled="data_case.length > 0"  
                                     >
                                    send
                                </v-btn>
                                </v-col>        -->
                                <v-col cols="12">
                                    <v-simple-table  class="table-inv mt--10 mb-2">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center ">Case ID</th>
                                            <th class="text-center">count</th>
                                            <th class="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="data_case_main.length > 0">
                                            <tr v-for="(row, index) in data_case_main" :key="index" >
                                            <td class="text-center">{{ index + 1 }}</td>
                                            <td class="text-center">{{ row.case_id }}</td>
                                            <td class="text-center ">{{ row.count }}</td>
                                            <td class="text-center">
                                            <v-btn  dense  x-small fab  @click="sendcase_id(row)" >
                                                <v-icon  color="orange">mdi-chevron-right</v-icon>
                                            </v-btn>
                                            </td>              
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4" class="text-center">No result</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                </v-col>
                                <v-col v-if="new_case" cols="12" :style="{ marginTop: '5px' }">
                                    <v-alert  class="class text-center " type="success" variant="outlined" 
                                    :style="{ fontWeight: 'bold', fontSize: 'medium' }"> New Case ID : {{ new_case }}</v-alert>
                                </v-col>                 
                            </v-row> 
                            <br v-if="data_case.length > 0">
                                <hr v-if="data_case.length > 0">
                                <div :style="{ marginTop: '25px', marginBottom: '25px' }" v-if="data_case.length > 0">
                                    <span class="text-h5" style="font-weight: bold; ">Case Count</span>
                                <v-simple-table  class="table-inv mt-5 mb-2" >
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">Case ID</th>
                                            <th class="text-center ">Main Case ID</th>
                                            <th class="text-center ">Case Status ID</th>
                                            <th class="text-center ">Sub Case Status ID</th>
                                            <th class="text-center">WO</th>
                                            <th class="text-center">Case Title</th>
                                            <th class="text-center">Remark</th>
                                            <th class="text-center">S/N</th>
                                            <th class="text-center">Customer Name</th>
                                            <th class="text-center">Engineer</th>
                                            <th class="text-center">OnSite At</th>
                                            <th class="text-center">Run Case Number</th>
                                            <th class="text-center">Del</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in data_case" :key="index" >
                                            <td class="text-center">{{ index + 1 }}</td>
                                            <td class="text-center">{{ row.case_id }}</td>
                                            <td class="text-center ">{{ row.maincase_id }}</td>
                                            <td class="text-center ">{{ row.case_status_id }}</td>
                                            <td class="text-center ">{{ row.subcase_status_id }}</td>
                                            <td class="text-center">{{ row.wonumber }}</td>
                                            <td class="text-center">{{ row.case_title }}</td>
                                            <td class="text-center">{{ row.remark }}</td>
                                            <td class="text-center">{{ row.product_serial }}</td>
                                            <td class="text-center">{{ row.customer_name }}</td>
                                            <td class="text-center">{{ row.engineer }}</td>
                                            <td class="text-center">{{ row.onsite_at }}</td>
                                            <td class="text-center">
                                            <v-btn  dense v-if="data_case.length !== 1 && index === data_case.length - 1" x-small fab @click="handleAction(row)">
                                                <v-icon  color="orange">mdi-chevron-right</v-icon>
                                            </v-btn>
                                            </td>
                                            <td class="text-center">
                                                <v-btn  dense v-if="data_case.length !== 1 && index === data_case.length - 1" x-small fab @click="handleDelCase(row)">
                                                <v-icon  color="red">mdi-delete</v-icon>
                                            </v-btn>
                                            </td>              
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                    </v-container>
                </div>
            </v-expand-transition>
        </v-card>
    </v-col>
        <v-col cols="12" md="6" lg="6" class="pa-2 ma-2">
            <v-card v-if="team_name === 'PROGRAMMER'">
                    <v-card-title>
                        Count NonHP Main Case
                        <v-btn
                            x-small
                            fab
                            class="ml-3"
                            :color="
                                chk_data_nonHP_main == false
                                    ? 'green accent-2'
                                    : 'amber'
                            "
                            @click="get_dataNonHP()"
                            ><v-icon>mdi-refresh</v-icon></v-btn
                        >           
                        <v-spacer></v-spacer>
                        <v-btn icon @click="showCountNonHP = !showCountNonHP">
                            <v-icon>{{
                                showCountNonHP ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                        </v-btn>
                    </v-card-title>
                <v-expand-transition>
                    <div v-show="showCountNonHP">
                        <v-container fluid> 
                                <v-simple-table  class="table-inv mt--10 mb-2">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center ">Main Case ID</th>
                                            <th class="text-center">count</th>
                                            <th class="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="data_nonHP_main.length > 0">
                                            <tr v-for="(row, index) in data_nonHP_main" :key="index" >
                                            <td class="text-center">{{ index + 1 }}</td>
                                            <td class="text-center">{{ row.nonhp_maincase_id }}</td>
                                            <td class="text-center ">{{ row.count }}</td>
                                            <td class="text-center">
                                            <v-btn  dense  x-small fab  @click="handleSendNonHPMainCaseId(row)">
                                                <v-icon  color="orange">mdi-chevron-right</v-icon>
                                            </v-btn>
                                            </td>              
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4" class="text-center">No result</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <br v-if="data_nonHP_detail.length > 0">
                                <hr v-if="data_nonHP_detail.length > 0">
                                <div :style="{ marginTop: '25px', marginBottom: '25px' }" v-if="data_nonHP_detail.length > 0">
                                    <span class="text-h5" style="font-weight: bold; ">Case Count</span>
                                <v-simple-table  class="table-inv mt-5" >
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center ">NonHP Main Case ID</th>
                                            <th class="text-center ">NonHP Case ID</th>
                                            <th class="text-center">HP Case ID</th>
                                            <th class="text-center">NonHP Case Refer</th>
                                            <th class="text-center">Type</th>
                                            <th class="text-center">Status</th>
                                            <th class="text-center">del</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in data_nonHP_detail" :key="index" >
                                            <td class="text-center">{{ index + 1 }}</td>
                                            <td class="text-center">{{ row.nonhp_maincase_id }}</td>
                                            <td class="text-center">{{ row.nonhp_case_id }}</td>  
                                            <td class="text-center">{{ row.hp_case_id }}</td>                                            
                                            <td class="text-center">{{ row.nonhp_case_refer }}</td>
                                            <td class="text-center">{{ row.type }}</td>
                                            <td class="text-center ">{{ row.status }}</td>
                                            <td class="text-center">
                                            <v-btn  dense v-if="data_nonHP_detail.length !== 1 && index === data_nonHP_detail.length - 1" x-small fab @click="sendNonHPToDel(row)">
                                                <v-icon  color="red">mdi-delete</v-icon>
                                            </v-btn>

                                            </td>              
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                </div>
                               
                    </v-container>
                </div>
            </v-expand-transition>
        </v-card>
    </v-col>
</v-row>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>


       
    </div>
</template>

<script>
import axios from 'axios'; 


const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
                },
    mounted() {
            this.get_dataNonHP(); 
            this.get_dataRunCaseNumber();
            },
    methods: {
    async get_dataNonHP() {
        this.chk_data_nonHP_main = true
        await  axios
                .get(url + "it/task/check-case-nonhp", this.tk)
                .then((response) => {
                    this.data_nonHP_main = response.data
                    this.chk_data_nonHP_main = false
                    this.new_case = "";
                })
        },
    async get_dataRunCaseNumber() {
        this.chk_data_case_main = true
    await  axios
                .get(url + "it/task/get-case-number", this.tk)
                .then((response) => {
                    this.data_case_main = response.data
                    this.chk_data_case_main = false
                })
        },
    async handleSendNonHPMainCaseId(row) {
        let send = {
            nonhp_maincase_id :  row.nonhp_maincase_id
        };
        this.dialog_loading = true
        await axios
        .post(url + "it/task/get-case-nonhp", send, this.tk)
            .then(response => {
                this.data_nonHP_detail = response.data
                this.dialog_loading = false
            })
            .catch(error => {
                console.error(error);
            });
    },
    sendNonHPToDel(row){
        let send = {
            id: row.id,
            nonhp_maincase_id :  row.nonhp_maincase_id
        };
        this.$swal({
            title: `ต้องการที่จะลบข้อมูล ${row.hp_case_id} ใช่ไหม?`,
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => { 
                if (confirm) {             
                axios
                .post(url + "it/task/del-case-nonhp", send, this.tk)
                .then(response => {
                this.data_nonHP_detail = response.data
                this.$swal(`ลบข้อมูล ${row.hp_case_id} เรียบร้อยแล้ว`, "", "success");
            })
            .catch(error => {
                console.error(error);
            });
                }
            })
    },    
    async sendcase_id(row) {
            let send = {
                case_id: row.case_id,
            }

            this.dialog_loading = true
        await axios
            .post(url + "it/task/check-case-number", send, this.tk)
            .then(response => {
                this.data_case = response.data
                this.new_case=""
                this.dialog_loading = false
            })
            .catch(error => {
                console.error(error);
            });
                    },
    handleAction(row) {
        let send = {
            maincase_id: row.maincase_id,
            case_id: row.case_id
            };
            this.$swal({
            title: `ต้องการแก้ไขข้อมูล ${row.maincase_id} ใช่ไหม?`,
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => { 
                if (confirm) {  
                    axios
                    .post(url + "it/task/run-case-number", send)
                    .then(response => {
                    this.data_case = response.data.check_old
                    this.new_case = response.data.case_new
                    this.get_dataRunCaseNumber();
                    this.$swal(`แก้ไขข้อมูลเป็น ${response.data.case_new} เรียบร้อยแล้ว`, "", "success");
                    
        })
        .catch(error => {
            console.error(error);
        });
            }
    })
    },  
    handleDelCase(row) {
        let send = {
            maincase_id: row.maincase_id,
            };
            this.$swal({
            title: `ต้องลบ ${row.maincase_id} ใช่ไหม?`,
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => { 
                if (confirm) {  
                    axios
                    .post(url + "it/task/del-case-number", send)
                    .then(response => {
                    this.data_case = response.data.check_old
                    this.get_dataRunCaseNumber();
                    this.data_case=[];
                    this.$swal(`ลบข้อมูลเรียบร้อยแล้ว`, "", "success");
                    
        })
        .catch(error => {
            console.error(error);
        });
            }
    })  
    }           
},
    data() {
        return {
            chk_data_nonHP_main: false,
            chk_data_case_main: false,
            team_name: localStorage.team_name,
            case_id: "",
            tk: null,
            dialog_loading: false,
            data_case_main : [],
            data_case : [],
            data_nonHP_main : [],
            data_nonHP_detail : [],
            showRunCaseNumber: true,
            showCountNonHP: false,
            new_case: "",
            
        }
    },
}
</script>

<style>

</style>